import {getServerSideProps as spellifySSP} from "@/pages/spellify/index";
import SpellifyPage from "@/pages/spellify/index";


export default SpellifyPage

export const getServerSideProps = spellifySSP
